import { put, takeEvery } from 'redux-saga/effects';
import { CreateUserViewModel, UserViewModel } from 'stageclip-common';

import { RequestAction } from 'actions/allActions';
import { FormSubmitAction } from 'actions/formActions';
import { createModalOpenAction } from 'actions/modalActions';
import { runApiRequest } from 'actions/saga/sagaActions';
import { CreateUserRequest } from 'api/definitions/createUserRequest';
import { EditUserRequest } from 'api/definitions/editUserRequest';
import { SimpleModalId } from 'constants/modalId';
import { ClientsActionTypes } from './clients.action-types';
import {
  addUserSuccess,
  AddUserSuccess,
  editUserSuccess,
  EditUserSuccess,
  FetchUserRequest,
  fetchUsersSuccess,
} from './clients.actions';
import { FetchClientsUsers } from './clients.requests';

function* fetchAllUsers(action: FetchUserRequest & Omit<RequestAction, 'type'>) {
  const { payload, requestingComponent, dispatch } = action;
  const request = new FetchClientsUsers(payload.id, requestingComponent, dispatch);

  // @ts-ignore
  yield runApiRequest(request, fetchUsersSuccess);
}

function* addUser(action: AddUserSuccess & FormSubmitAction<CreateUserViewModel>) {
  const { formData, requestingComponent, dispatch } = action;

  const request = new CreateUserRequest(formData, requestingComponent, dispatch);

  // @ts-ignore
  yield runApiRequest(request, addUserSuccess);
}

function* handleAddUserSuccess(action: AddUserSuccess) {
  const user = action.payload.entities.users[action.payload.result];

  yield put(createModalOpenAction(SimpleModalId.ClientsUserSuccessMessage, { user }));
}

function* editUser(action: Omit<EditUserSuccess, 'type'> & FormSubmitAction<UserViewModel>) {
  const {
    formData: { id, clientId, ...formData },
    requestingComponent,
    dispatch,
  } = action;

  const request = new EditUserRequest(id, formData, requestingComponent, dispatch);

  // @ts-ignore
  yield runApiRequest(request, editUserSuccess);
}

export function* clientSaga() {
  yield takeEvery(ClientsActionTypes.FETCH_CLIENT_USERS_REQUEST, fetchAllUsers);
  yield takeEvery(ClientsActionTypes.ADD_CLIENT_USERS_REQUEST, addUser);
  yield takeEvery(ClientsActionTypes.EDIT_CLIENT_USER_REQUEST, editUser);
  yield takeEvery(ClientsActionTypes.ADD_CLIENT_USERS_SUCCESS, handleAddUserSuccess);
}
